module.exports = __webpack_public_path__ + "img/farming_7.39bd0dde.png";